import {Button} from '@/components/ui/button'

export function ExportActionButtons({
  testidPrefix,
  excelLabel,
  printLabel,
  pending,
  error,
  onExcel,
  onPrint,
}: {
  testidPrefix: string
  excelLabel: string
  printLabel: string
  pending: 'excel' | 'print' | null
  error: string | null
  onExcel: () => void
  onPrint: () => void
}) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testidPrefix}-export-buttons`}>
      <Button
        size="sm"
        variant="outline"
        disabled={pending !== null}
        onClick={onExcel}
        data-testid={`${testidPrefix}-download-excel`}>
        {excelLabel}
      </Button>
      <Button
        size="sm"
        variant="outline"
        disabled={pending !== null}
        onClick={onPrint}
        data-testid={`${testidPrefix}-open-print`}>
        {printLabel}
      </Button>
      {error && (
        <p className="text-xs text-destructive" data-testid={`${testidPrefix}-export-error`}>
          {error}
        </p>
      )}
    </div>
  )
}
